import {
  Button,
  Container,
  HStack,
  Icon,
  useBoolean,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import { FaGift, FaWallet } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import WalletAssetsContainer from '../containers/WalletAssetsContainer';
import useConnectedAccount from '../hooks/useConnectedAccount';
import useTranslate from '../hooks/useTranslate';
import FeatureFlag from '../types/featureFlag';
import { isFeatureEnabled } from '../utils/featueFlagsUtils';
import { getShortenedAddress } from '../utils/walletUtils';
import IncentivesPopup from './IncentivesPopup';
import Logo from './Logo';
import MainMenu from './MainMenu';
import Panel from './Panel';
import WalletPopup from './WalletPopup';

const Header: React.FC = () => {
  const translate = useTranslate();
  const [walletAddress] = useConnectedAccount();
  const [isWalletDialogVisible, setIsWalletDialogVisible] = useBoolean();
  const [isIncentivesPopupOpen, setIsIncentivesPopupOpen] = useBoolean(false);

  return (
    <>
      <Panel as="header" px="0" pt="6" pb="0" borderRadius="0">
        <Container>
          <VStack align="stretch" spacing="6">
            <HStack overflow="hidden" spacing="3">
              <Link to="/">
                <Logo w="9em" />
              </Link>

              <HStack justify="flex-end" w="full" spacing="3">
                {isFeatureEnabled(FeatureFlag.DynamicNftSale) && (
                  <Button
                    flex="none"
                    color="bright.50"
                    borderColor="dark.500"
                    _hover={{
                      borderColor: 'primary.500',
                    }}
                    borderStyle="dashed"
                    colorScheme="bright"
                    borderRadius="full"
                    variant="outline"
                    size="sm"
                    ml="100%"
                    leftIcon={<Icon as={FaGift} color="primary.500" />}
                    onClick={setIsIncentivesPopupOpen.on}
                  >
                    {translate('common:incentives')}
                  </Button>
                )}

                {walletAddress && (
                  <Button
                    flex="none"
                    color="bright.50"
                    borderColor="dark.500"
                    _hover={{
                      borderColor: 'primary.500',
                    }}
                    colorScheme="bright"
                    borderRadius="full"
                    variant="outline"
                    size="sm"
                    leftIcon={
                      isFeatureEnabled(
                        FeatureFlag.DynamicNftSale
                      ) ? undefined : (
                        <Icon as={FaWallet} color="primary.500" />
                      )
                    }
                    onClick={setIsWalletDialogVisible.on}
                  >
                    {getShortenedAddress(walletAddress, 3)}
                  </Button>
                )}
              </HStack>
            </HStack>

            <VStack
              spacing="3"
              w="full"
              align="stretch"
              pb={isFeatureEnabled(FeatureFlag.TraitsSwapping) ? '0' : '6'}
            >
              <WalletAssetsContainer />
              {isFeatureEnabled(FeatureFlag.TraitsSwapping) ? (
                <MainMenu />
              ) : null}
            </VStack>
          </VStack>
        </Container>
      </Panel>

      {isWalletDialogVisible && (
        <WalletPopup isOpen onClose={setIsWalletDialogVisible.off} />
      )}

      {isIncentivesPopupOpen && (
        <IncentivesPopup
          isOpen
          onClose={() => setIsIncentivesPopupOpen.off()}
        />
      )}
    </>
  );
};

export default Header;
